<template>
  <div :class="$style.container">
    <div :class="$style.header">
      <TextComponent :class="$style.title" type="heading4" color="teal" as="h2">
        {{ index !== undefined ? `${index + 1}. ` : ''
        }}{{ `${source.code}` }}
      </TextComponent>
      <TextComponent type="body2" as="span">
        <strong>
          # Members: {{ source.memberNames.length }}
        </strong>
      </TextComponent>
    </div>
    <Stack direction="column" spacing="tad">
      <TextComponent :class="$style.text" type="body3">
        Team Score: {{ source.teamScore === undefined ? 'N/A' : source.teamScore }}
      </TextComponent>
      <TextComponent :class="$style.text" type="body3" v-for="name in source.memberNames" :key="name">
        {{ name }}
      </TextComponent>
    </Stack>
  </div>
</template>

<script>
  import Stack from '@hackthe6ix/vue-ui/Stack';
  import Text from '@hackthe6ix/vue-ui/Text';

  export default {
  name: 'TeamCard',
  components: {
    TextComponent: Text,
    Stack,
  },
  props: {
    base: {
      type: String,
      default: '',
    },
    index: Number,
    source: Object,
  },
};
</script>

<style lang="scss" module src="./TeamCard.module.scss" />
